import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { painPoints } from '../data/content';
const story = ['The customer says the battery goes dead overnight.', 'You charge it.', 'You test the battery.', 'Everything appears normal.'];
export function ProblemSection() {
  return <section className="w-full bg-navy py-16 sm:py-24" aria-labelledby="problem-title" data-id="element-243" data-mp="39hm8wu9z3k0p">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-244" data-mp="35gas9e92u94n">
        <SectionHeading title={<span id="problem-title" data-id="element-246" data-mp="3jg1z8v16ep95">
              The battery keeps dying.{' '}
              <span className="text-volt" data-id="element-247" data-mp="3jdza0d7ul05h">But what’s actually causing it?</span>
            </span>} data-id="element-245" data-mp="35fiy87v4ojgh" />

        <div className="mx-auto mt-10 max-w-2xl space-y-2 border-l-4 border-volt pl-5 text-lg text-white sm:text-xl" data-id="element-248" data-mp="1p2152ngkmqfe">
          {story.map(line => <p key={line} data-id="element-249" data-mp="1k4iqohjsbj00">{line}</p>)}
          <p className="pt-2 font-bold text-alert" data-id="element-250" data-mp="jddecdssymy6">
            Two days later, the vehicle returns with exactly the same problem.
          </p>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-base text-mist sm:text-lg" data-id="element-251" data-mp="ocg995f2jcsf">
          Now you’re facing one of the most frustrating electrical diagnostic situations in automotive
          repair. The problem isn’t necessarily a lack of electrical knowledge —{' '}
          <strong className="text-white" data-id="element-252" data-mp="122tfn3cbajfn">it’s the absence of a consistent diagnostic sequence.</strong>
        </p>

        <h3 className="mt-12 text-center font-display text-2xl font-bold uppercase text-white sm:text-3xl" data-id="element-253" data-mp="1714tdp5q9e35">
          Without a structured workflow, investigations turn into:
        </h3>
        <ul className="mx-auto mt-6 grid max-w-4xl gap-3 md:grid-cols-2" data-id="element-254" data-mp="1g22zcczq7vod">
          {painPoints.map(p => <li key={p} className="flex items-start gap-3 rounded-xl bg-ink/70 px-4 py-3.5 text-[15px] font-medium text-white sm:text-base" data-id="element-255" data-mp="3duyra1vldyv3">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert/20" data-id="element-256" data-mp="p120m7zeoxn6">
                <XIcon className="h-4 w-4 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-257" data-mp="k30gdjq8usa4" />
              </span>
              {p}
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg font-semibold text-white sm:text-xl" data-id="element-258" data-mp="tyaie7gn6znw">
          You don’t need another textbook explaining automotive electricity. You need a practical
          pathway that tells you <span className="text-volt" data-id="element-259" data-mp="12ziecivoroet">what to check, what to document,</span> and how to
          determine the next testing step.
        </p>

        <SectionCta label="Give me the diagnostic pathway" data-id="element-260" data-mp="1cq3cy6bd0sxq" />
      </div>
    </section>;
}